import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
const statusStyles = {
    active: { background: 'var(--success-soft)', color: 'var(--success)' },
    closed: { background: 'var(--surface-alt)', color: 'var(--text-muted)' },
    disputed: { background: 'var(--danger-soft)', color: 'var(--danger-fg)' },
};
export function ScopeBarExpanded({ framework, periodStart, periodEnd, packageHash, verifyHref, status, onCopyHash, }) {
    const handleCopy = useCallback(async () => {
        if (!packageHash)
            return;
        try {
            await navigator.clipboard.writeText(packageHash);
        }
        catch {
            /* clipboard API unavailable — swallow gracefully */
        }
        onCopyHash?.();
    }, [packageHash, onCopyHash]);
    const statusStyle = statusStyles[status];
    const truncatedHash = packageHash ? `${packageHash.slice(0, 8)}…` : null;
    return (_jsxs("div", { role: "banner", "aria-label": "Engagement scope", "data-scope-bar-expanded": true, style: {
            background: 'var(--warning-subtle)',
            borderBottom: '1px solid var(--border)',
            padding: 'var(--sp-2) var(--sp-3)',
        }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--sp-2)',
                    flexWrap: 'wrap',
                }, children: [_jsx("span", { style: {
                            background: 'var(--warning-chip-bg)',
                            color: 'var(--warning-text)',
                            fontSize: 'var(--fs-xs)',
                            fontWeight: 600,
                            padding: '2px 8px',
                            borderRadius: 'var(--radius-sm)',
                        }, children: framework }), _jsx("span", { style: {
                            background: statusStyle.background,
                            color: statusStyle.color,
                            fontSize: 'var(--fs-xs)',
                            fontWeight: 600,
                            padding: '2px 8px',
                            borderRadius: 'var(--radius-sm)',
                            textTransform: 'capitalize',
                        }, children: status }), truncatedHash && (_jsxs("span", { style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                            marginLeft: 'auto',
                        }, children: [_jsx("code", { style: {
                                    fontFamily: "var(--font-mono)",
                                    fontSize: 'var(--fs-xs)',
                                    color: 'var(--warning-text)',
                                }, children: truncatedHash }), _jsx("button", { type: "button", onClick: handleCopy, "aria-label": "Copy package hash", title: "Copy full hash", style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 24,
                                    height: 24,
                                    padding: 0,
                                    border: 'none',
                                    borderRadius: 'var(--radius-sm)',
                                    background: 'transparent',
                                    color: 'var(--warning-text)',
                                    cursor: 'pointer',
                                }, children: _jsxs("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("rect", { x: 5.5, y: 5.5, width: 8, height: 8, rx: 1.5, stroke: "currentColor", strokeWidth: 1.25 }), _jsx("path", { d: "M10.5 5.5V3.25C10.5 2.56 9.94 2 9.25 2H3.25C2.56 2 2 2.56 2 3.25v6c0 .69.56 1.25 1.25 1.25H5.5", stroke: "currentColor", strokeWidth: 1.25 })] }) })] }))] }), _jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'var(--sp-2)',
                    marginTop: 'var(--sp-1)',
                }, children: [_jsxs("span", { style: {
                            color: 'var(--warning-text)',
                            fontSize: 'var(--fs-xs)',
                        }, children: [periodStart, " \u2013 ", periodEnd] }), verifyHref && (_jsx("a", { href: verifyHref, style: {
                            color: 'var(--warning-text)',
                            fontSize: 'var(--fs-xs)',
                            fontWeight: 500,
                            textDecoration: 'underline',
                            marginLeft: 'auto',
                        }, children: "Verify" }))] })] }));
}
//# sourceMappingURL=ScopeBarExpanded.js.map